// Meta Pixel utility functions
// Pixel ID: 1408713430802123

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let pixelInitialized = false

// Initialize Meta Pixel
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (pixelInitialized) return

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  // Set up the fbq stub to queue calls before script loads
  if (!f.fbq) {
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Load the script
  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    b.head.appendChild(t)
  }

  // Initialize with Pixel ID
  window.fbq('init', '1408713430802123')

  pixelInitialized = true
}

// Track PageView event
export function trackPageView() {
  if (typeof window === 'undefined') return
  // Ensure pixel is initialized first
  if (!pixelInitialized) {
    initMetaPixel()
  }
  window.fbq('track', 'PageView')
}

// Track AddToCart event - returns a Promise that resolves after the event is sent
export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || !window.fbq) {
      resolve()
      return
    }

    const eventData = {
      content_name: params?.content_name || 'Metabo-Reset 40+',
      content_ids: params?.content_ids || ['44441705480271'],
      content_type: params?.content_type || 'product',
      value: params?.value || 10.0,
      currency: params?.currency || 'USD',
    }

    window.fbq('track', 'AddToCart', eventData)

    // Also send via sendBeacon as fallback to ensure delivery before page unload
    try {
      const pixelUrl = `https://www.facebook.com/tr/?id=1408713430802123&ev=AddToCart&cd[content_name]=${encodeURIComponent(eventData.content_name)}&cd[content_ids]=${encodeURIComponent(JSON.stringify(eventData.content_ids))}&cd[content_type]=${eventData.content_type}&cd[value]=${eventData.value}&cd[currency]=${eventData.currency}&noscript=1`

      if (navigator.sendBeacon) {
        navigator.sendBeacon(pixelUrl)
      }
    } catch (e) {
      // Silently fail - the fbq call above should handle it
    }

    // Give the pixel time to send the request
    setTimeout(resolve, 300)
  })
}

// Generic track event function
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}
